@if (aprovacaoLoading) {
  <app-loading-box height="72" margin="0 0 14px 0"></app-loading-box>
  <app-loading-box height="120"></app-loading-box>
} @else if (aprovacao) {
  @if (!aprovacao.requerAprovacao) {
    <div class="ced-aprov-info">
      <mat-icon class="material-symbols-outlined">info</mat-icon>
      <span>Esta compra não requer aprovação — o valor está abaixo da alçada configurada.</span>
    </div>
  } @else {
    <div class="ced-aprov-summary">
      <div class="ced-aprov-summary__item">
        <span class="ced-mini-label">Status</span>
        <span class="status-badge"
          [class.badge-verde]="aprovacao.statusGeral === 'aprovado'"
          [class.badge-vermelho]="aprovacao.statusGeral === 'reprovado'"
          [class.badge-amarelo]="aprovacao.statusGeral !== 'aprovado' && aprovacao.statusGeral !== 'reprovado'">
          {{ aprovacaoStatusLabel }}
        </span>
      </div>
      <div class="ced-aprov-summary__item">
        <span class="ced-mini-label">Valor avaliado</span>
        <span class="ced-aprov-val">R$ {{ cotFmt(aprovacao.valorAvaliado || 0) }}</span>
      </div>
      <div class="ced-aprov-summary__item">
        <span class="ced-mini-label">Aprovações</span>
        <span class="ced-aprov-val">{{ aprovacao.qtdAprovados }} de {{ aprovacao.qtdAprovadoresRequeridos }}</span>
      </div>
    </div>
  }

  <!-- Somente leitura: edita-se em Pedido de Compra. -->
  <div class="section-title">
    <mat-icon>inventory_2</mat-icon>
    <span>Itens do pedido</span>
    <span class="status-badge badge-cinza">{{ pedidoItens.length }}</span>
  </div>
  <div class="ced-aprov-items">
    @for (it of pedidoItens; track it.idCompraItem || it.sku || it.name) {
      <div class="ced-aprov-item">
        <div class="ced-aprov-item__info">
          <div class="ced-product-name">{{ it.name }}</div>
          <div class="ced-aprov-item__sup">
            {{ it.qty }} {{ it.unit }} × R$ {{ pedidoPrecoUnitario(it) }}
            @if (pedidoDesconto(it) > 0) {
              <span>· desconto R$ {{ cotFmt(pedidoDesconto(it)) }}</span>
            }
            @if (pedidoTributos(it) > 0) {
              <span>· tributos R$ {{ cotFmt(pedidoTributos(it)) }}</span>
            }
          </div>
        </div>
        <span class="ced-aprov-item__val">R$ {{ cotFmt(pedidoSubtotal(it)) }}</span>
      </div>
    } @empty {
      <div class="ced-aprov-item">
        <span class="ced-empty-text">Nenhum item no pedido.</span>
      </div>
    }
    <div class="ced-aprov-resumo-row">
      <span>Itens</span>
      <span class="ced-section-spacer"></span>
      <span class="ced-aprov-resumo-row__val">R$ {{ cotFmt(pedidoItensTotal) }}</span>
    </div>
    <div class="ced-aprov-resumo-row">
      <span>Frete</span>
      <span class="ced-section-spacer"></span>
      <span class="ced-aprov-resumo-row__val">R$ {{ cotFmt(pedidoFrete) }}</span>
    </div>
    <div class="ced-aprov-resumo-row">
      <span>Outras despesas</span>
      <span class="ced-section-spacer"></span>
      <span class="ced-aprov-resumo-row__val">R$ {{ cotFmt(pedidoOutrasDespesas) }}</span>
    </div>
    <div class="ced-aprov-items__total">
      <span>Total do pedido</span>
      <span class="ced-section-spacer"></span>
      <span class="ced-aprov-items__total-val">R$ {{ cotFmt(pedidoTotal) }}</span>
    </div>
  </div>

  @if (pedidoParcelas.length) {
    <span class="ced-mini-label">Parcelas</span>
    <div class="ced-aprov-parcelas">
      @for (p of pedidoParcelas; track p.sequencia) {
        <span class="ced-aprov-parcela">
          {{ p.sequencia }}ª · {{ p.dias != null ? p.dias + ' dias' : 'sem prazo' }} ·
          <strong>R$ {{ cotFmt(p.valor || 0) }}</strong>
        </span>
      }
    </div>
  }

  <!-- Justificativa da escolha, redigida na cotação — contexto somente-leitura para a decisão. -->
  @if (justificativaCotacao) {
    <div class="section-title">
      <mat-icon>edit_note</mat-icon>
      <span>Justificativa da escolha</span>
    </div>
    <div class="ced-aprov-just">{{ justificativaCotacao }}</div>
  }

  @if (aprovacao.requerAprovacao) {
    <!-- Decisão do aprovador -->
    @if (podeAprovar) {
      <div class="ced-aprov-decision">
        <div class="ced-aprov-decision__title">Decisão do aprovador</div>
        <div class="ced-aprov-decision__sub">Aprovar registra a decisão. Rejeitar exige justificativa e destino.</div>

        <div class="ced-aprov-decision__btns">
          <!-- Reprovar depois do envio revogaria a aprovação que o autorizou: o backend recusa. -->
          @if (pedidoEnviado) {
            <span class="ced-aprov-revert__lock">
              <mat-icon class="material-symbols-outlined">lock</mat-icon> Pedido já enviado — não é possível reprovar
            </span>
          } @else {
            <button mat-stroked-button type="button" class="btn-secondary"
              [disabled]="aprovacaoSaving" (click)="abrirRejeicao()">
              <mat-icon class="material-symbols-outlined">do_not_disturb_on</mat-icon> Rejeitar pedido
            </button>
          }
          <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="aprovando"
            [disabled]="aprovacaoSaving" [attr.aria-label]="aprovando ? 'Aprovando pedido' : 'Aprovar pedido'"
            (click)="aprovarPedido()">
            <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
            Aprovar pedido
            @if (aprovando) { <mat-spinner diameter="20"></mat-spinner> }
          </button>
        </div>

        @if (aprovacaoRejeicaoAberta) {
          <div class="ced-aprov-reject">
            <div class="ced-field">
              <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
                <mat-label>Destino após rejeição</mat-label>
                <mat-select [(ngModel)]="aprovacaoRejeicaoDestino" required>
                  @for (d of rejeicaoDestinos; track d.key) {
                    <mat-option [value]="d.key">Voltar para {{ d.nome }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="ced-field">
              <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
                <mat-label>Justificativa</mat-label>
                <textarea matInput rows="2" [(ngModel)]="aprovacaoJustificativa" required
                  placeholder="Descreva o motivo da rejeição para o solicitante…"></textarea>
              </mat-form-field>
            </div>
            <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="rejeitando"
              [disabled]="aprovacaoSaving" [attr.aria-label]="rejeitando ? 'Rejeitando pedido' : 'Confirmar rejeição'"
              (click)="confirmarRejeicao()">
              <mat-icon class="material-symbols-outlined">do_not_disturb_on</mat-icon>
              Confirmar rejeição
              @if (rejeitando) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
          </div>
        }
      </div>
    } @else if (aprovacao.statusGeral === 'pendente') {
      <div class="ced-aprov-info">
        <mat-icon class="material-symbols-outlined">lock</mat-icon>
        <span>Aguardando aprovação dos perfis autorizados. Seu perfil não pode aprovar esta etapa.</span>
      </div>
    }

    <!-- Reverter a própria aprovação; indisponível depois do envio (o backend recusa). -->
    @if (aprovacao.aprovadoPeloUsuarioAtual) {
      <app-alert-card type="success">
        Você aprovou este pedido.
        <div alertActions>
          @if (pedidoEnviado) {
            <span class="ced-aprov-revert__lock">
              <mat-icon class="material-symbols-outlined">lock</mat-icon> Pedido já enviado — não é possível revogar
            </span>
          } @else {
            <button mat-stroked-button type="button" class="btn-secondary btn-spinner" [class.btn-loading]="cancelandoAprovacao"
              [disabled]="aprovacaoSaving"
              [attr.aria-label]="cancelandoAprovacao ? 'Cancelando aprovação' : 'Cancelar minha aprovação'"
              (click)="cancelarAprovacao()">
              <mat-icon class="material-symbols-outlined">undo</mat-icon>
              Cancelar minha aprovação
              @if (cancelandoAprovacao) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
          }
        </div>
      </app-alert-card>
    }
  }

  <!-- Fora do @if de requerAprovacao: compra abaixo da alçada também é enviada daqui. -->
  <app-ced-envio-pedido
    [envio]="pedido.envio"
    [habilitado]="envioLiberado"
    motivoBloqueio="Aprove o pedido para liberar o envio ao fornecedor."
    (enviarPedido)="enviarPedido.emit($event)">
  </app-ced-envio-pedido>

  @if (aprovacao.requerAprovacao) {
    @if (aprovacao.historico.length) {
      <div class="section-title">
        <mat-icon>history</mat-icon>
        <span>Histórico de decisões</span>
      </div>
      <div class="ced-aprov-hist">
        @for (h of aprovacao.historico; track h.idCompraAprovacao) {
          <div class="ced-aprov-hist__row">
            <mat-icon class="material-symbols-outlined ced-aprov-hist__ico"
              [class.is-aprovado]="h.idStatusAprovacao === 1"
              [class.is-reprovado]="h.idStatusAprovacao === 2">
              {{ h.idStatusAprovacao === 1 ? 'check_circle' : 'cancel' }}
            </mat-icon>
            <div class="ced-aprov-hist__body">
              <div class="ced-aprov-hist__top">
                <span class="ced-aprov-hist__who">{{ aprovacaoNomeAprovador(h.idUsuarioAprovador) }}</span>
                <span class="ced-aprov-hist__sep">·</span>
                <span class="ced-aprov-hist__status">{{ h.statusDescricao }}</span>
                <span class="ced-section-spacer"></span>
                <span class="ced-aprov-hist__when">{{ h.datetimeInclusao | date:'dd/MM/yyyy HH:mm' }}</span>
              </div>
              @if (h.justificativa) {
                <div class="ced-aprov-hist__just">{{ h.justificativa }}</div>
              }
            </div>
          </div>
        }
      </div>
    }
  }
} @else {
  <p class="ced-empty-text">Nenhum dado de aprovação carregado.</p>
}
